import defaultProfile, { getOrderedConfDefSections } from "./default";
import { commonMenuItems } from "./common";
import type { ConfigSection, Menu, ProfileCtx } from "./types";

const PACKAGES_DIRS: Record<string, string> = {
  EuroTruckSimulator2Profile: ".local/share/Euro Truck Simulator 2",
  AmericanTruckSimulatorProfile: ".local/share/American Truck Simulator",
};

function createMenu(): Menu {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
}

function getConfigSections(ctx: ProfileCtx): ConfigSection[] {
  const packagesDir = PACKAGES_DIRS[ctx?.profile?.name ?? ""] ?? "";
  const sections: ConfigSection[] = [{ component: "ServerPackages", props: { packagesDir } }];
  for (const [name, section] of getOrderedConfDefSections(ctx)) {
    const component = section.template === "table" ? "TableSection" : "ConfSection";
    sections.push({ component, props: { name } });
  }
  return sections;
}

export default (ctx: ProfileCtx) => ({
  menu: createMenu(),
  configSections: getConfigSections(ctx),
});
